const LoadingText = () => {
  return <div className="loading">Loading...</div>;
};

export default LoadingText;
